<template>
    <div id="create-software-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Software</h1>
                <SoftwareForm @formSubmitted="createSoftware" />
            </section>
        </div>
    </div>
</template>

<script>
import SoftwareForm from '@/components/forms/SoftwareForm.vue'

const endpoint = process.env.VUE_APP_API_BASE + '/softwares/create'
import axios from 'axios'

export default {
    name: 'SoftwaresCreate',
    components: {
        SoftwareForm
    },
    data: function () {
        return {}
    },
    methods: {
        createSoftware(data) {
            axios.post(endpoint, data)
                .then(response => {
                    console.log(response)
                    alert('Software created successfully')
                    this.$router.push('/softwares')
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response && error.response.data?.data) {
                        alert(error.response.data.data)
                    } else {
                        alert('Error occurred!')
                        console.log(error)
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
